import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export function BookVisibilityCard() {
  const [employers, setEmployers] = useState(null);
  const [hidden, setHidden] = useState(new Set());
  const [busy, setBusy] = useState(false);

  const apply = (list) => { setEmployers(list); setHidden(new Set(list.filter((e) => e.hidden).map((e) => e.name))); };
  useEffect(() => {
    api.get("/admin/book-summary/visibility").then(({ data }) => apply(data.employers))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, []);
  useEffect(() => {
    if (employers && window.location.hash === "#book-summary-visibility") {
      document.getElementById("book-summary-visibility")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [employers]);

  if (!employers) return null;
  const toggle = (name) => {
    const next = new Set(hidden);
    if (next.has(name)) next.delete(name); else next.add(name);
    setHidden(next);
  };
  const dirty = employers.some((e) => e.hidden !== hidden.has(e.name));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/book-summary/visibility", { hidden: [...hidden] });
      apply(data.employers); toast.success("Book summary updated");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <section className="border p-6 mt-4" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid="book-visibility-card">
      <p className="text-sm mb-4 max-w-2xl" style={{ color: "var(--muted)" }}>
        Choose which employers appear in the Book summary at the top of the Overview. Hidden employers keep all
        their data and still appear everywhere else.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2 mb-5">
        {employers.map((e) => (
          <label key={e.name} className="flex items-center gap-2 text-sm cursor-pointer" data-testid={`book-visibility-row-${e.name}`}>
            <input type="checkbox" checked={!hidden.has(e.name)} onChange={() => toggle(e.name)}
                   data-testid={`book-visibility-toggle-${e.name}`} />
            <span style={{ color: hidden.has(e.name) ? "var(--muted)" : "var(--ink)" }}>{e.name}</span>
          </label>
        ))}
      </div>
      <button type="button" className="btn-primary" disabled={busy || !dirty} onClick={save} data-testid="book-visibility-save">Save</button>
    </section>
  );
}
